import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import classNames from 'classnames';
import Checkbox from '../../../shared/components/Checkbox/Checkbox';


const RefinementValues = function RefinementValuesComponent({
  group, values, refinementHandler, focused, setFocused, focusedRef, origin, theme,
}) {
  const isFocused = value => focused &&
    focused.origin === origin &&
    focused.id === value.id &&
    focused.displayValue === value.displayValue;

  useEffect(() => {
    if (values.find(isFocused)) {
      focusedRef.current.focus();
    }
  }, [values]);

  return (
    <>
      {
        values && !!values.length && values.length > 0 &&
          values.map((value) => {
            if (value.url === '#') {
              return null;
            }

            const valueId = uniqueId(`${group}_value_`);
            const ref = isFocused(value) ? focusedRef : null;

            const labelClasses = classNames('results-grid__checkbox', {
              [`results-grid__checkbox--${theme}`]: theme,
            });

            return (
              <Checkbox
                key={valueId}
                labelRef={ref}
                className={labelClasses}
                id={valueId}
                isSelected={value.selected}
                onChange={() => {
                  setFocused({ ...value, origin });
                  refinementHandler(value.url);
                }}
              >
                {value.displayValue}
              </Checkbox>
            );
          })
      }
    </>
  );
};

RefinementValues.propTypes = {
  group: PropTypes.string.isRequired,
  refinementHandler: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  focused: PropTypes.shape({
    id: PropTypes.string,
    displayValue: PropTypes.string,
    origin: PropTypes.string,
  }),
  setFocused: PropTypes.func.isRequired,
  focusedRef: PropTypes.shape({
    current: PropTypes.shape({ focus: PropTypes.func }),
  }).isRequired,
  origin: PropTypes.string.isRequired,
  theme: PropTypes.string,
};

RefinementValues.defaultProps = {
  focused: null,
  theme: undefined,
};

export default RefinementValues;
